import React = require('react');
import {useEffect, useState} from 'react';
import {IPaymentWalletProviderConfigData} from '../../../../data/api/models';

type GooglePayButtonType = React.ComponentType<any>;

type GooglePayWrapperProps = {
  grossPremium: string;
  onGooglePayLoadPaymentData: (paymentData: google.payments.api.PaymentData) => void;
  paymentWalletProviderConfigData: IPaymentWalletProviderConfigData;
};

const GooglePayWrapper = ({
                            grossPremium,
                            onGooglePayLoadPaymentData,
                            paymentWalletProviderConfigData
                          }: GooglePayWrapperProps) => {
  const [GooglePayButton, setGooglePayButton] = useState<GooglePayButtonType | null>(null);

  useEffect(() => {
    import('@google-pay/button-react').then((module) => {
      // @ts-ignore
      setGooglePayButton(() => module);
    });
  }, []);

  if (!GooglePayButton) return null;

  const paymentRequest: google.payments.api.PaymentDataRequest = {
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [
      {
        type: 'CARD',
        parameters: {
          allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
          allowedCardNetworks: ['AMEX', 'MASTERCARD', 'VISA'],
        },
        tokenizationSpecification: {
          type: 'PAYMENT_GATEWAY',
          parameters: {
            gateway: 'barclayssmartpayadvance',
            gatewayMerchantId: paymentWalletProviderConfigData.googlePay.gatewayMerchantId,
          },
        },
      },
    ],
    merchantInfo: {
      merchantId: paymentWalletProviderConfigData.googlePay.merchantId, // Test Merchant ID
      merchantName: paymentWalletProviderConfigData.googlePay.displayName,
    },
    transactionInfo: {
      totalPriceStatus: 'FINAL',
      totalPriceLabel: 'Total',
      totalPrice: grossPremium,
      currencyCode: 'GBP',
      countryCode: 'GB',
    },
  };

  return (
    <GooglePayButton
      environment={paymentWalletProviderConfigData.googlePay.environment}
      buttonColor="black"
      buttonType="plain"
      buttonRadius={10}
      buttonBorderType="no_border"
      paymentRequest={paymentRequest}
      onLoadPaymentData={onGooglePayLoadPaymentData}
      buttonSizeMode="fill"
      className="gateway-payment-button"
      buttonHeight={40}
    />
  );
}


export default GooglePayWrapper;
